import { getItemAbsoluteBox } from 'app/core/markers/bounds';
export const renderSpotsWithComposition = (spots, ctx, area) => {
    if (!spots.length) {
        return;
    }
    ctx.save();
    const defaultCompositionOperation = ctx.globalCompositeOperation;
    ctx.globalCompositeOperation = 'source-over';
    ctx.fillStyle = 'rgba(0,0,0,0.4)';
    ctx.beginPath();
    ctx.moveTo(area.x - 1, area.y - 1);
    ctx.lineTo(area.x - 1, area.y + area.height + 2);
    ctx.lineTo(area.x + area.width + 2, area.y + area.height + 2);
    ctx.lineTo(area.x + area.width + 2, area.y - 1);
    ctx.closePath();
    ctx.fill();
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fillStyle = 'black';
    spots.forEach(mark => {
        const spot = mark;
        ctx.beginPath();
        switch (mark.type) {
            case 'ellipse':
                {
                    const cx = spot.endX * 0.5;
                    const cy = spot.endY * 0.5;
                    ctx.ellipse(spot.x + cx, spot.y + cy, Math.abs(cx), Math.abs(cy), 0, 0, 2 * Math.PI);
                }
                break;
            case 'rect':
                {
                    const bounds = getItemAbsoluteBox(spot);
                    ctx.rect(bounds.x, bounds.y, bounds.width, bounds.height);
                }
                break;
            default:
                break;
        }
        ctx.closePath();
        ctx.fill();
    });
    ctx.globalCompositeOperation = defaultCompositionOperation;
    ctx.resetTransform();
    ctx.restore();
};
// export const renderSpotsWithClipping = (context: RendererContext) => {
//     const { markers, image, getCanvas } = context;
//     const { spots } = markers;
//     if (!spots.length) {
//         return;
//     }
//     const canvas = getCanvas(CanvasLayers.spots);
//     const ctx = canvas.getContext('2d');
//     ctx.save();
//     ctx.fillStyle = 'rgba(0,0,0,0.4)';
//     ctx.beginPath();
//     ctx.moveTo(0, 0);
//     ctx.lineTo(0, canvas.height + 1);
//     ctx.lineTo(canvas.width + 1, canvas.height + 1);
//     ctx.lineTo(canvas.width + 1, 0);
//     ctx.closePath();
//     ctx.fill();
//     ctx.beginPath();
//     ctx.fillStyle = 'black';
//     spots.forEach(mark => {
//         const spot = mark as SpotMarker;
//         const cx = spot.endX * 0.5;
//         const cy = spot.endY * 0.5;
//         ctx.ellipse(
//             spot.x + cx,
//             spot.y + cy,
//             Math.abs(cx),
//             Math.abs(cy),
//             0,
//             0,
//             2 * Math.PI
//         );
//         ctx.closePath();
//     });
//     ctx.clip();
//     const transform = ctx.getTransform();
//     ctx.resetTransform();
//     ctx.drawImage(
//         image,
//         0,
//         0,
//         image.width,
//         image.height,
//         0,
//         0,
//         canvas.width,
//         canvas.height
//     );
//     ctx.setTransform(transform);
//     renderBlurs(context);
//     ctx.restore();
// };
